import React from 'react';

const ProgressBar = ({ raisedFunds, requiredFunds }) => {
    // Calculate the percentage of raised funds
    const percentage = (raisedFunds / requiredFunds) * 100;

    return (
        <div className="w-full bg-white rounded-full ">
            <div
                className="h-2 rounded-full bg-purple"
                style={{ width: `${percentage}%` }}
            ></div>
        </div>
    );
};

export default ProgressBar;
